import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { FilterControlComponent, FilterControl, FilterControlOptions } from './filter-control';
import { map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  templateUrl: './chips-input-filter-control.html',
  styles: [
    `
      .input-chip-list {
        width: 100%;
      }
      .mat-mdc-chip.mat-mdc-standard-chip {
        font-size: 12px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChipsInputFilterControlComponent implements FilterControlComponent, OnInit {
  control: ChipsInputFilterControl;
  formGroup: UntypedFormGroup;
  controlValue$: Observable<string[]>;

  ngOnInit(): void {
    this.controlValue$ = this.control.valueChanges.pipe(
      startWith(this.control.value),
      map((data) => {
        this.control.ctrlValue = data;
        return data;
      }),
    );
  }

  private splitInput(regex: RegExp, input: string): string[] {
    // Split input based on regex input
    return input
      .replace(regex, ',')
      .trim()
      .split(',')
      .filter((data) => !!data);
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    let value = event.value;
    let dirty = false;

    // Set all caps if enabled
    if (this.control.allCaps) {
      value = value.toUpperCase();
    }

    if (this.control.regexSeparator) {
      const splitInput = this.splitInput(this.control.regexSeparator, value);
      if (!!splitInput && splitInput.length > 0) {
        dirty = true;
        this.control.ctrlValue.push(...splitInput);
      }
    } else {
      // Add new value to list
      if ((value || '').trim()) {
        dirty = true;
        this.control.ctrlValue.push(value.trim());
      }
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
    // Set the control value
    if (dirty) {
      this.control.setValue(this.control.ctrlValue);
    }
  }

  remove(option: string): void {
    const index = this.control.ctrlValue.indexOf(option);

    if (index >= 0) {
      this.control.ctrlValue.splice(index, 1);
    }
    this.control.setValue(this.control.ctrlValue);
  }
}

export class ChipsInputFilterControl extends FilterControl {
  component = ChipsInputFilterControlComponent;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  constructor(
    public name: string,
    public label?: string,
    public allCaps?: boolean,
    public regexSeparator?: RegExp,
    public ctrlValue?: string[],
    formState?: any,
    opts: FilterControlOptions = {},
  ) {
    super(name, label, formState, opts);
    if (!this.ctrlValue) {
      this.ctrlValue = [];
    }
    this.setValue(this.ctrlValue);
  }
}
